import React, { createContext, useContext, useEffect, useState } from 'react';
import { login, loginAdmin } from '../services/auth';
import { getSession } from '../services/service';
import { toastActions } from '../components/uielements/toast/toast';

export const AuthContext = createContext(undefined);

export const AuthProvider = ({ children }) => {
  const [session, setSession] = useState(undefined);

  useEffect(() => {
    if (!session) {
      setSession(getSession());
    }
  }, []);

  const handleLogin = async (username, password, isAdmin = false, isMapper = false) => {
    try {
      let s;

      if (isAdmin) {
        s = await loginAdmin(username, password);
      } else if (isMapper) {
        s = await loginAdmin(username, password);
      } else {
        s = await login(username, password);
      }

      if (s) {
        setSession(s);
        localStorage.setItem('session', JSON.stringify(s));
        isAdmin
          ? localStorage.setItem('userRole', 'admin')
          : isMapper
            ? localStorage.setItem('userRole', 'mapper')
            : localStorage.setItem('userRole', 'user');
        return s;
      } else {
        setSession(undefined);
        return undefined;
      }
    } catch (e) {
      setSession(undefined);
      throw e;
    }
  };

  const handleLogout = () => {
    toastActions.success('You have successfully logged out of Urban Compass.');
    setSession(undefined);
    localStorage.removeItem('session');
    localStorage.removeItem('userRole');
  };

  const value = {
    session,
    login: handleLogin,
    logout: handleLogout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
